<div class="p-4 text-center">
  <h4 class="font-medium !text-2xl">{{ title | concat | translate }}</h4>

  <div>
    <p>{{ message  }}</p>
  </div>
  <div class="flex flex-wrap !justify-center" mat-dialog-actions>
    <button *ngFor="let data of buttons" [mat-dialog-close]="data.value" mat-raised-button
            class="!rounded-lg !text-white {{ data?.value ? '!bg-primary' : '!bg-red-500'}}">
      {{ (data?.title ? data?.title : 'Yes') | concat | translate  }}
    </button>
  </div>
</div>
